export default __webpack_public_path__ + "static/media/flag-niue.c68d9fa1.svg";